import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import MonthlyReportService from '../../services/MonthlyReportService';

const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const mapRow = (row, index) => {
  const current = {
    workDays: toNum(row.Total_Working_Days),
    casual: toNum(row.Casual),
    annual: toNum(row.Annual),
    sick: toNum(row.Sick),
  
    noPay: 0,
    duty: 0,
    setOff: 0,
    leaveTotal: toNum(row.Casual) + toNum(row.Annual) + toNum(row.Sick),
    absent: toNum(row.Total_Absent),
    late: toNum(row.Late_Attendance),
    short: toNum(row.Short_Leave),
    adj: toNum(row.Adjusted_OT_Paid),

    extra: 0,
    sunday: 0,
    actualWorkDays: toNum(row.Actual_Work_Days),
  };

  return {
    id: row.HAD_EMPLOYEE_ID ?? index,
    serviceNo: row.Service_No,
    name: row.NAME,
    category: row.CATEGORY,
    status: row.EMPLOYEE_STATUS,
    designation: row.Designation,
    current,
    total: { ...current },
  };
};

export const fetchMonthlyReport = createAsyncThunk(
  'monthlyReport/fetch',
  async ({ year, month }, { rejectWithValue }) => {
    try {
      const response = await MonthlyReportService.GetHREMPDetailsReport(year, month);
      const data = response?.data ?? response;
      const results = data?.ResultSet ?? data?.resultSet ?? [];
      return results.map(mapRow);
    } catch (err) {
      const status = err?.response?.status;
      const msg =
        status === 401
          ? 'Unauthorized — please sign in again.'
          : err?.response?.data?.message || err.message || 'Failed to load report.';
      return rejectWithValue(msg);
    }
  }
);

const initialState = {
  rows: [],
  loading: false,
  error: null,
};

const monthlyReportSlice = createSlice({
  name: 'monthlyReport',
  initialState,
  reducers: {
    clearMonthlyReport(state) {
      state.rows = [];
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlyReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonthlyReport.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload;
      })
      .addCase(fetchMonthlyReport.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export const { clearMonthlyReport } = monthlyReportSlice.actions;
export default monthlyReportSlice.reducer;